module.exports = __webpack_public_path__ + "static/media/slide6.1317e313.jpg";